import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Divider,
  makeStyles
} from "@fluentui/react-components";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { ResetButton } from "./ResetButton";

const useStyles = makeStyles({
  accordionPanel: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px"
  },
  accordionRow: {
    display: "flex",
    minHeight: "var(--lineHeightBase600, 32px)",
    gap: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  },
  accordionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  }
});

export function AudioVideoSettings({ audioChildren, videoChildren, onResetToDefaultAudio }) {
  const intl = useIntl();
  const styles = useStyles();

  return (
    <div>
      <Accordion collapsible multiple defaultOpenItems={["1", "2"]}>
        <AccordionItem value="1">
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <FormattedMessage id="room-settings-sidebar.audio-settings" defaultMessage="Audio" />
              <ResetButton onClick={onResetToDefaultAudio} />
            </div>
          </AccordionHeader>
          <AccordionItem value="1">
            <AccordionPanel className={styles.accordionPanel}>{audioChildren}</AccordionPanel>
          </AccordionItem>
        </AccordionItem>
        <Divider />
        <AccordionItem value="2">
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <span>{intl.formatMessage({ id: "room-settings-sidebar.video-settings", defaultMessage: "Video" })}</span>
              {/* <ResetButton onClick={onResetToDefaultVideo} /> */}
            </div>
          </AccordionHeader>
          <AccordionItem value="2">
            <AccordionPanel className={styles.accordionPanel}>{videoChildren}</AccordionPanel>
          </AccordionItem>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

// Add proptypes
AudioVideoSettings.propTypes = {
  audioChildren: PropTypes.node,
  videoChildren: PropTypes.node,
  onResetToDefaultAudio: PropTypes.func,
  onResetToDefaultVideo: PropTypes.func
};
